import { Carousel, Skeleton } from "antd";

export default function Banner({ merchant, isLoading, coverSlide, handleClickBottomMenu }: any) {
    return (
        <div className="wrapper-cover-img">
            <Skeleton active loading={isLoading} title={true} paragraph={false}>
                <Carousel dots={false} afterChange={coverSlide}>
                    {merchant?.themes?.banner[0]?.bannerNormal?.map((item: any, index: any) => (
                        <div
                            className="layout-cover-img"
                            key={index}
                            onClick={() => handleClickBottomMenu(item.bannerLink)}
                        >
                            <img src={item.bannerImage} alt="cover" />
                        </div>
                    ))}
                </Carousel>
            </Skeleton>
        </div>
    );
}
